"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const task_service_1 = require("./task.service");
const task_controller_1 = require("./task.controller");
const jwt_1 = require("@nestjs/jwt");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const entities_1 = require("../../../../service-lib/src/lib/entities");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const typeorm_1 = require("@nestjs/typeorm");
const task_repository_1 = require("./task.repository");
const look_up_service_1 = require("../../../../org-service/src/app/look-up/look-up.service");
const look_up_module_1 = require("../../../../org-service/src/app/look-up/look-up.module");
let TaskModule = class TaskModule {
};
exports.TaskModule = TaskModule;
exports.TaskModule = TaskModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([
                entities_1.Task,
                entities_1.Company,
                entities_1.Opportunity,
                entities_1.TaskDocumentMap,
                entities_1.FileUpload,
                entities_1.LookUp,
                entities_1.OpportunityActivityMap,
            ]),
            jwt_1.JwtModule,
            look_up_module_1.LookUpModule,
        ],
        controllers: [task_controller_1.TaskController],
        providers: [
            task_service_1.TaskService,
            task_repository_1.TaskRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            entity_service_utils_1.EntityService,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
            look_up_service_1.LookUpService,
        ],
        exports: [task_service_1.TaskService, task_repository_1.TaskRepository],
    })
], TaskModule);
